import { useEffect } from 'react';

import i18n from 'i18next';
import { useDispatch, useSelector } from 'react-redux';

import { initI18n } from 'i18n/i18nService';
import { setLanguage, setLanguageInitialized, setLanguageLoading } from 'store/actions/language';
import { handleError } from 'utils/helper';

export const LanguageProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { currentLanguage, isInitialized, availableLanguages } = useSelector((state) => state.language);

  useEffect(() => {
    const init = async () => {
      try {
        dispatch(setLanguageLoading(true));
        const savedLang = localStorage.getItem('i18nextLng') || currentLanguage || availableLanguages[0].code;
        await initI18n(savedLang);

        dispatch(setLanguage(savedLang));
        dispatch(setLanguageInitialized(true));
        document.documentElement.lang = savedLang;
      } catch (error) {
        handleError(error);
      } finally {
        dispatch(setLanguageLoading(false));
      }
    };

    init();
  }, [dispatch]);

  if (!isInitialized) {
    return (
      <div data-testid="loading" id="loading" className="fixed inset-0 flex-middle-center bg-gray-800 bg-opacity-50 z-max">
        <div className="w-26 h-26 rounded-lg bg-white flex-middle-center">
          <img className="animate-spin" src={require('assets/resources/Loading.png')} alt="loading" width={72} height={72} />
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default i18n;
